import React, { useRef, useState, useEffect } from 'react';
import ReactMapGL, { FlyToInterpolator } from 'react-map-gl';
import { easeCubicInOut } from 'd3-ease';
import IconMarkers from './partials/IconMarkers';
import SitesMarkers from './partials/SitesMarkers';
import { defaultIcons } from 'data/defaultProducts';

import ZoomControl from './ZoomControl';
import 'mapbox-gl/dist/mapbox-gl.css';

const onlySites = defaultIcons.reduce((acc, item) => {
  acc = [...(acc || []), ...item.sites];
  return acc;
}, []);
const { token: accessToken } = require('config.json');

const Map = ({ setDialogue, dialogue, setSiteImage }) => {
  const mapRef = useRef(null);
  const [viewport, setViewport] = useState({
    longitude: -20,
    latitude: 27,
    zoom: 1.5,
  });
  const [isZoomed, setIsZoomed] = useState(false); //boolean

  const setZoom = zoom => setViewport({ ...viewport, zoom });

  const onSetDialogue = country => {
    setTimeout(() => {
      setDialogue(country);
    }, 1000);
    setViewport(viewport => ({
      ...viewport,
      longitude: country.latLng[0],
      latitude: country.latLng[1],
      zoom: 5.5,
      transitionDuration: 2000,
      transitionInterpolator: new FlyToInterpolator(),
      transitionEasing: easeCubicInOut,
    }));
  };

  useEffect(() => {
    const isZoomedIn = viewport.zoom > 5;

    if (isZoomed && !isZoomedIn) {
      setDialogue(undefined);
      setSiteImage(undefined);
    }
    setIsZoomed(isZoomedIn);
  }, [isZoomed, setDialogue, setSiteImage, viewport]);

  return (
    <ReactMapGL
      {...viewport}
      ref={mapRef}
      mapStyle={'mapbox://styles/mapbox/light-v9'}
      width="100vw"
      height="100vh"
      mapboxApiAccessToken={accessToken}
      onViewportChange={setViewport}
    >
      {!isZoomed ? (
        <IconMarkers setDialogue={onSetDialogue} />
      ) : (
        <SitesMarkers sites={onlySites} setSiteImage={setSiteImage} />
      )}

      <ZoomControl setZoom={setZoom} zoom={viewport.zoom} />
    </ReactMapGL>
  );
};

export default Map;
